export default function nombreEnTexte(input) {
    const unites = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf"];
    const dizaines = ["", "dix", "vingt", "trente", "quarante", "cinquante", "soixante", "soixante", "quatre-vingt", "quatre-vingt"];
    const exceptions = ["dix", "onze", "douze", "treize", "quatorze", "quinze", "seize"];

    // Return "zéro dinar" if the input is 0 or "0"
    if (input === 0 || input === "0") return "zéro dinar";

    function convertir(n) {
        if (n < 10) return unites[n];
        if (n < 17) return exceptions[n - 10];
        if (n < 20) return "dix-" + unites[n - 10];
        if (n < 70) {
            const dizaine = Math.floor(n / 10);
            const unite = n % 10;
            return dizaines[dizaine] + (unite === 1 ? "-et-" : (unite > 0 ? "-" : "")) + unites[unite];
        }
        if (n < 80) {
            return "soixante-" + convertir(n - 60);
        }
          if (n < 90) {
        
            const unite = n % 10;

            return "quatre-vingt" + (unite > 0 ? "-" + unites[unite] : "");
        }
        if (n < 100) {
            const unite = n % 10;
            return "quatre-vingt-" + convertir(n - 80)
            // return "quatre-vingt-" + (unite > 0 ? "-" + unites[unite] : "");
        }
        if (n < 1000) {
            const centaine = Math.floor(n / 100);
            const reste = n % 100;
            return (centaine > 1 ? unites[centaine] + "-cent" : "cent") + (reste > 0 ? "-" + convertir(reste) : "");
        }
        if (n < 1000000) {
            const mille = Math.floor(n / 1000);
            const reste = n % 1000;
            return (mille > 1 ? convertir(mille) + "-mille" : "mille") + (reste > 0 ? "-" + convertir(reste) : "");
        }
        if (n < 1000000000) {
            const million = Math.floor(n / 1000000);
            const reste = n % 1000000;
            return (million > 1 ? convertir(million) + "-millions" : "un-million") + (reste > 0 ? "-" + convertir(reste) : "");
        }
        return "Nombre trop grand à convertir";
    }

    function convertirPrix(nombre) {
        // Validate the input
        if (nombre === null || nombre === undefined || nombre === "") {
            throw new Error("Le nombre fourni n'est pas valide");
        }

        const parsedNombre = typeof nombre === "number" ? nombre : parseFloat(nombre);
        if (isNaN(parsedNombre)) {
            throw new Error("Le nombre fourni n'est pas valide");
        }

        const parts = parsedNombre.toFixed(3).split(".");
        const dinars = parseInt(parts[0], 10);
        const millimes = parseInt(parts[1], 10);

        // Convert dinars and millimes to text
        const texteDinars = dinars > 0 ? convertir(dinars) + " dinar" + (dinars > 1 ? "s" : "") : "";
        const texteMillimes = millimes > 0 ? convertir(millimes) + " millime" + (millimes > 1 ? "s" : "") : "";

        // Combine the dinars and millimes text
        if (texteDinars && texteMillimes) {
            return `${texteDinars} et ${texteMillimes}`;
        } else if (texteDinars) {
            return texteDinars;
        } else {
            return texteMillimes;
        }
    }

    return convertirPrix(input);
}
